import { Data } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';

export interface IDocumentsApiClient {

    getFileUrl(fileDescriptorId: number, inline: boolean): AxiosPromise<string>;

    getInvestorFileUrl(fileDescriptorId: number, investorId: number): AxiosPromise<string>;

    getUploadDocumentUrl(): string;

    // Client only properties / methods

    getFileDownloadUrl(fileDescriptorId: number): AxiosPromise<string>;

    getFileInlineUrl(fileDescriptorId: number): AxiosPromise<string>;
}

@injectable()
export default class DocumentsApiClient extends Data.ApiClientBase implements IDocumentsApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/documents`);
    }

    public getFileUrl(fileDescriptorId: number, inline: boolean): AxiosPromise<string> {
        return this.axios.get(`${this.apiPath}/uri/${fileDescriptorId}?inline=${inline}`);
    }

    public getInvestorFileUrl(fileDescriptorId: number, investorId: number): AxiosPromise<string> {
        return this.axios.get(`${this.apiPath}/investor/uri/${fileDescriptorId}?investorId=${investorId}`);
    }

    public getUploadDocumentUrl(): string {
        return `${this.apiPath}`;
    }

    // Client only properties / methods

    getFileDownloadUrl(fileDescriptorId: number): AxiosPromise<string> {
        return this.getFileUrl(fileDescriptorId, false);
    }

    getFileInlineUrl(fileDescriptorId: number): AxiosPromise<string> {
        return this.getFileUrl(fileDescriptorId, true);
    }
}